import React from "react";
import { i18n } from "../translate/i18n";
import "./language.css";
import EN from "../../assets/flagUsa.png";
import BR from "../../assets/flagBrazil.png";

const I18N_STORAGE_KEY = "i18nextLng";

export const Language = () => {
  const handleSelectChange = (event) => {
    // eslint-disable-next-line no-self-assign

    window.localStorage.setItem(I18N_STORAGE_KEY, event.target.value);

    // eslint-disable-next-line no-self-assign
    window.location = window.location;
  };

  return (
    <>
      <div className="flag__container container">
        <select onChange={handleSelectChange} className="data__flags">
          <option>{i18n.t("home.lg")}</option>
          <option value="pt-BR">
            {i18n.t("home.pt")}
            <img src={BR} alt="" />
          </option>
          <option value="en-US">
            {i18n.t("home.en")}
            <img src={EN} alt="" />
          </option>
        </select>
      </div>
      {/*
      <div className="changeLng__container container">
        <div className="changeLng__content" onClick={handleSelectChange}>
          <div className="flagLng">
            <img src={EN} alt="" value={"en-US"} />
          </div>
          <div className="flagLng">
            <img src={BR} alt="" value={"pt-BR"} />
          </div>
        </div>
      </div> */}
    </>
  );
};
